import { API_BASE_URL, SERVICE_URL } from "./conf";
import axios from "axios";

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.withCredentials = true;
const config = { headers: { "Content-Type": "multipart/form-data" } };

/* axios请求拦截/响应拦截 */
const pendingRequest = new Map();
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

function generateReqKey(config: any) {
  const { data } = config;
  return [JSON.stringify(data)];
}

function resGenerateReqKey(config: any) {
  const { data } = config;
  return [data];
}

function addPendingRequest(config: any) {
  const requestKey = generateReqKey(config);
  config.cancelToken = config.cancelToken || new axios.CancelToken((cancel: any) => {
    if (!pendingRequest.has(requestKey)) {
      pendingRequest.set(requestKey, cancel);
    }
  })
}

function removePendingRequest(config: any) {
  const requestKey = generateReqKey(config);
  if (pendingRequest.has(requestKey)) {
    config.cancelToken = source.token;
    source.cancel();
  }
}

function clearPending() {
  for (const [requestKey, cancelToken] of pendingRequest) {
    cancelToken(requestKey);
  }
  pendingRequest.clear();
}

axios.interceptors.request.use(
  function (config: any) {
    removePendingRequest(config);
    addPendingRequest(config);
    return config;
  },
  (error) => {
    pendingRequest.clear();
    return Promise.reject(error);
  }
)

axios.interceptors.response.use(
  (response) => {
    const requestKey = resGenerateReqKey(response.config);
    pendingRequest.delete(requestKey);
    if (response.data.code !== 200) {
    }
    return response;
  },
  (error) => {
    removePendingRequest(error.config || {});
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    } else {

    }
    return Promise.reject(error);
  }
)

/**
 * WebAPI对axios简单封装
 */
export class WebApi {
  public invoke(request: IRequestInfo, headers?: any): Promise<IRes> {
    return this.post(SERVICE_URL, request, headers);
  }

  public get(url: string, params?: object): Promise<IRes> {
    let param = {
      accept:
        "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8"
    };
    if (params) {
      param = { ...params, ...param };
    }
    return axios.get(url, { params: param });
  }

  public post(urlstr: string, params?: object, headers?: any) {
    return axios({
      method: "post",
      url: urlstr,
      data: params,
      ["headers"]: headers
    });
  }
}

export default WebApi;

export function invoke(request: IRequestInfo): Promise<IRes> {
  return axios({
    method: "post",
    url: "api/service",
    data: request
  });
}

export function get(url: string, params?: object) {
  let param = {
    accept:
      "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8"
  };
  if (typeof params === "object") {
    param = { ...params, ...param };
  }
  return axios.get(url, { params: param });
}

// export default invoke;
